export default __webpack_public_path__ + "static/media/large-frame-bg2.8f3c5d16.svg";